import React from 'react';
import { Row } from 'reactstrap';
import classnames from 'classnames';

interface Option {
    key: any;
    label: string;
}

interface SelectOptionProps {
    selectedOption: any;
    setSelectedOption: (type: any) => void;
    options: Option[];
    readOnly?: boolean;
    filterSelected?: boolean;
    invalid?: boolean;
    nowrap?: boolean;
}

const SelectOption: React.FC<SelectOptionProps> = ({
    selectedOption,
    setSelectedOption,
    options,
    readOnly,
    filterSelected,
    invalid,
    nowrap,
}) => {
    const visibleOptions = filterSelected
        ? options.filter(({ key }) => key === selectedOption)
        : options;

    return (
        // <div className={classnames("form-control px-4 py-2", { "border border-danger": invalid })} dir="ltr">
            <div className={classnames('gap-2 d-flex', nowrap ? 'flex-nowrap' : 'flex-wrap')}>
                {visibleOptions.map(({ key, label }) => (
                    <div
                        key={key}
                        role="button"
                        tabIndex={readOnly ? -1 : 0}
                        aria-pressed={selectedOption === key}
                        aria-disabled={Boolean(readOnly)}
                        className={
                            'form-control d-flex align-items-center justify-content-between ' +
                            (selectedOption === key ? 'border border-success bg-checkbox' : '')
                        }
                        style={{
                            borderRadius: '5px',
                            cursor: 'pointer',
                            height: '35px',
                            width: 'auto',
                            flex: nowrap ? '1 1 0' : undefined,
                            minWidth: nowrap ? 0 : undefined,
                            padding: '0px 5px 0px 12px',
                        }}
                        onClick={() => {
                            if (!readOnly) setSelectedOption(key);
                        }}
                        onKeyDown={(event) => {
                            if (!readOnly && (event.key === 'Enter' || event.key === ' ')) {
                                event.preventDefault();
                                setSelectedOption(key);
                            }
                        }}
                    >
                        <span
                            className={classnames({
                                'text-success fw-normal': selectedOption === key,
                                'text-truncate': nowrap,
                            })}
                        >
                            {label}
                        </span>

                        <div
                            className={`border-default ${selectedOption === key ? 'border-success' : ''}`}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                paddingLeft: '5px',
                                marginLeft: '12px',
                                height: '100%',
                            }}
                            >
                            <i
                                className={`fa ${selectedOption === key
                                    ? 'fa-solid fa-square-check text-success'
                                    : 'fa-light fa-square'
                                    }`}
                                style={{
                                    fontSize: '20px',
                                    color: '#e2e2e2',
                                    fontWeight: selectedOption === key ? '' : '200',
                                }}
                            />
                        </div>
                    </div>
                ))}
            </div>
        // </div>
    );
};

export default SelectOption;
